import React from "react";
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from "react-icons/fa";
export default function BelowLogoScrollingText() {
    return (
        <div className="marquee-wrapper">
            <div class="marqueebelowlogo">
                <div class="marquee-track">
                    <span>We are the manufacturer/ Wholesaler / dealer / distburter / Retailer of All kinds of Family wear.</span>
                    <span>We are the manufacturer/ Wholesaler / dealer / distburter / Retailer of All kinds of Family wear.</span>
                </div>
            </div>
        </div>
    );
}